import { Skeleton } from "@mantine/core";

/**
 * Skeleton for the order confirmation page:
 * success icon, event card summary, booking details.
 */
export default function ConfirmationSkeleton() {
  return (
    <div className="max-w-md w-full flex flex-col bg-white">
      {/* Success icon area */}
      <div className="flex flex-col items-center gap-3 p-6">
        <Skeleton height={64} width={64} circle />
        <Skeleton height={22} width="60%" radius="sm" />
        <Skeleton height={14} width="40%" radius="sm" />
      </div>

      {/* Event summary card */}
      <div className="flex gap-4 items-center p-4 border-t border-gray-200">
        <Skeleton height={80} width={80} radius="md" />
        <div className="flex flex-col gap-2 flex-1">
          <Skeleton height={18} width="70%" radius="sm" />
          <Skeleton height={14} width="50%" radius="sm" />
          <Skeleton height={14} width="40%" radius="sm" />
        </div>
      </div>

      {/* Booking details rows */}
      <div className="flex flex-col gap-3 p-4 border-t border-gray-200">
        {[1, 2, 3, 4].map((i) => (
          <div key={i} className="flex justify-between">
            <Skeleton height={14} width="30%" radius="sm" />
            <Skeleton height={14} width="40%" radius="sm" />
          </div>
        ))}
      </div>
    </div>
  );
}
